// El puente con Zoco, el portal de cuentas (instrucSesiones del repo de Zoco, sesión 6).
//
// Una sesión de Zoco entra por /entrar?codigo= (pages/auth/EntrarDesdeZoco.jsx) y trae adentro el
// negocio en el que se para el panel. Tickets no elige negocio: para cambiarlo se vuelve al
// portal, que emite otro código con el negocio nuevo. Es el mismo criterio que el front del PDV
// (ZocoPDV: frontend/src/aplicacion/zoco.ts).

const ZOCO_URL = String(process.env.REACT_APP_ZOCO_URL || "").replace(/\/+$/, "");

/** El portal: para cambiar de negocio, y adonde se vuelve al salir o cuando la sesión vence. */
export const urlDelPortal = (ruta = "/") => `${ZOCO_URL}${ruta}`;

/**
 * El `volver` del portal: adónde entrar dentro de Tickets. El portal divide Tickets en sus
 * módulos (eventos, mesas, canchas) y manda la ruta acá.
 *
 * Solo rutas de este mismo front. `volver` viaja por la URL y cualquiera puede escribirlo:
 * sin esto, un link con `?volver=https://otro-sitio` convertiría la entrada en un trampolín
 * hacia afuera. Una barra y no dos, que es como se escribe una URL absoluta sin esquema.
 * Devuelve null cuando no sirve, para que quien llama use su destino de siempre.
 */
export const rutaDeVuelta = (volver) =>
  typeof volver === "string" &&
  volver.startsWith("/") &&
  !volver.startsWith("//") &&
  !volver.startsWith("/\\")
    ? volver
    : null;

/** Marca de las sesiones que salieron del canje de Zoco, para distinguirlas de los logins propios de Tickets. */
export const ORIGEN_ZOCO = "zoco";

/** Si la sesión de redux salió del canje de Zoco: se renueva y se cierra contra Zoco, no contra Tickets. */
export const esSesionDeZoco = (auth) => auth?.origen === ORIGEN_ZOCO;
